<template>
    <NuxtLayout name="malt-base-layout">
        <VJoyFunnel class="legal-entity-creation-funnel">
            <VJoyTemplate>
                <template #template-main>
                    <VJoyStepper :step="currentCreationStep">
                        <template #default>
                            <VJoyStep v-for="step in legalEntitySteps" :key="step.tab">
                                {{ $t(`client.organization.settings.legal.entity.edit.tabs.${step.label}.title`) }}
                            </VJoyStep>
                        </template>
                    </VJoyStepper>
                    <div class="legal-entity-creation-funnel__header">
                        <VJoyText preset="secondary-200">
                            <slot name="title" />
                        </VJoyText>
                        <VJoyText slot="subtitle" preset="primary-300">
                            <slot name="subtitle" />
                        </VJoyText>
                    </div>
                    <KeepAlive>
                        <slot />
                    </KeepAlive>
                </template>
            </VJoyTemplate>
            <template #funnel-header>
                <VJoyFunnelHeader>
                    <template #funnel-header-right>
                        <NuxtLink :to="{name: 'organization-id-legal-entity-list'}">
                            <VJoyIconButton icon="cross" label="Close funnel" size="small" variant="ghost" />
                        </NuxtLink>
                    </template>
                </VJoyFunnelHeader>
            </template>
        </VJoyFunnel>
    </NuxtLayout>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {NuxtLink} from '#components';
    import {VJoyFunnel, VJoyFunnelHeader, VJoyStep, VJoyStepper, VJoyTemplate, VJoyText, VJoyIconButton} from '@maltjoy/core-vue';
    import {useLegalEntityStore} from '~/store/organization-settings/legal-entity-store';
    import type {LegalEntityFormTab} from '~/types/legalEntity';

    type LegalEntityFormLabels = 'details' | 'preferences' | 'affiliation';
    type LegalEntityFormStep = {
        tab: LegalEntityFormTab;
        label: LegalEntityFormLabels;
    };
    const legalEntitySteps: LegalEntityFormStep[] = [
        {tab: 'legal-entity-entityId-information', label: 'details'},
        {tab: 'legal-entity-entityId-preferences', label: 'preferences'},
        {tab: 'legal-entity-entityId-affiliation', label: 'affiliation'},
    ];
    const {currentCreationStep} = storeToRefs(useLegalEntityStore());
</script>
<style lang="scss">
    .legal-entity-creation-funnel {
        .joy-funnel__scrollable {
            padding-top: 0;
        }

        &__header {
            margin: var(--joy-core-spacing-10) 0 var(--joy-core-spacing-8) 0;
        }
    }
</style>
